import { LoginStep } from "@heidelbergmaterials/fcl-authclient"
import { useAuth, getDefaultRouteByPermissions } from "@shared/lib/auth"
import { transactions } from "@shared/routes"
import { LoadingPage } from "@shared/ui"
import { useEffect } from "react"
import { Navigate } from "react-router-dom"

export const RootRedirect: React.FC = () => {
	const {
		isAuthenticated,
		userPermissions,
		loginStep,
		fetchUserPermissions,
	} = useAuth()

	useEffect(() => {
		if (isAuthenticated && !userPermissions) {
			void fetchUserPermissions()
		}
	}, [isAuthenticated, userPermissions, fetchUserPermissions])

	if (!isAuthenticated && loginStep === LoginStep.Unauthenticated) {
		return <Navigate to={transactions} replace />
	}

	if (!userPermissions) {
		return <LoadingPage />
	}

	const defaultRoute = getDefaultRouteByPermissions(userPermissions)
	return <Navigate to={defaultRoute} replace />
}
